import React, { useEffect, useState } from "react";
import { Form, FormInput, Header, Segment } from "semantic-ui-react";
import CadastroService from "../services/cadastro.service";
import Loader from "./Loader";
import { showMessage } from '../helpers/helper';

const IdentificacaoPaciente = ({ location, match, history }) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location?.search);

        const email = params.get("email");
        const dataNascimento = params.get("dataNascimento");
        const chaveAcesso = params.get("chaveAcesso");
        setData({
            email,
            dataNascimento,
            chaveAcesso,
        });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        CadastroService.pacienteExistenteRecadastro(data)
            .then((res) => {
                const { success, data, message, error } = res.data;

                if (success) {
                    showMessage("Cadastro realizado com sucesso!");
                    history.push("/");
                    return;
                }

                if (message) showMessage(message);
                else showMessage("Ocorreu um erro durante a operação. Tente novamente mais tarde");
            })
            .finally(() => setLoading(false));
    };

    return (
        <>
            <div className="identificacao-paciente-container">
                <Segment className="identificacao-paciente-segment">
                    <Header as="h2">
                        <p>Cadastro de Novo Login</p>
                    </Header>
                    <p style={{ fontSize: "11px" }}>
                        Forneça a <b>chave de acesso</b>(n° no talão de atendimento), <b>CPF</b>, <b>email</b> e <b>senha</b> para cadastrar
                        seu novo usuário.
                    </p>
                    <Form size="large" className="identificacao-paciente-form" onSubmit={handleSubmit}>
                        <FormInput
                            fluid
                            icon={"key"}
                            iconPosition="left"
                            placeholder="Chave de Acesso"
                            value={data.chaveAcesso}
                            onChange={(e) => setData({ ...data, chaveAcesso: e.target.value })}
                            type={"number"}
                            required
                        />
                        <FormInput
                            fluid
                            icon={"credit card outline"}
                            iconPosition="left"
                            placeholder="CPF"
                            value={data.cpf}
                            onChange={(e) => setData({ ...data, cpf: e.target.value })}
                            type={"number"}
                            required
                        />
                        <FormInput
                            fluid
                            icon={"calendar alternate outline icon"}
                            iconPosition="left"
                            placeholder="Data de Nascimento"
                            value={data.dataNascimento}
                            onChange={(e) => setData({ ...data, dataNascimento: e.target.value })}
                            type={"date"}
                            required
                        />
                        <FormInput
                            fluid
                            icon={"at"}
                            iconPosition="left"
                            placeholder="Novo email"
                            value={data.email}
                            onChange={(e) => setData({ ...data, email: e.target.value })}
                            type={"email"}
                            required
                        />
                        <Form.Input
                            fluid
                            iconPosition="left"
                            icon={"lock"}
                            placeholder="Nova senha"
                            value={data.senha}
                            onChange={(e) => setData({ ...data, senha: e.target.value })}
                            type={"password"}
                            required
                        />

                        <Form.Button type={"submit"} fluid size="large" className="center">
                            Cadastrar
                        </Form.Button>
                    </Form>                    
                </Segment>
            </div>
            <Loader isLoading={loading} />
        </>
    );
};

export default IdentificacaoPaciente;
